import { render, staticRenderFns } from "./BlacklistManagement.vue?vue&type=template&id=1edc8499&scoped=true&"
import script from "./BlacklistManagement.vue?vue&type=script&lang=js&"
export * from "./BlacklistManagement.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistManagement.vue?vue&type=style&index=0&id=1edc8499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc8499",
  null
  
)

export default component.exports